/*
Application level routes configuration, this is used to
generate the <Route/> components using the react-router-config
library
*/
import { RouteConfig } from 'react-router-config';
import { default as VenueManagement } from '../containers/venue-management/VenueManagement';
import VenueProfileV2 from '../containers/VenueProfileV2';
import GuideLandingPage from '../components/guide-landing-page';
import AllStylesLandingPage from '../components/all-styles-landing-page';
import CuratedListsPage from '../containers/CuratedListsPage';
import { default as NotFound } from '../components/404';

import * as URLS from '.';
import * as HOTELS_URLS from './hotels-urls';
import MassInquiryPage from '../components/mass-inquiry';
import CCPADoNotSellContainer from '../containers/CCPADoNotSell';
import { SearchResultPageComponent } from '../components/search-result-page';
import { RFPEmailContainer } from '../components/rfpEmails';
import HotelsSearch from '../components/hotels-search/';
import HotelsLanding from '../components/hotels-landing';
import CheckOutWrapper from '../components/checkout/CheckOutWrapper';
import { FLAG_ROOM_BLOCK_RECOMMENDATIONS_ENABLED } from '@weddingspot/ws-api-client';

export enum VenueProfileRouteAction {
    CONTACT = 'contact',
    REQUEST_QUOTE = 'request-quote',
}

export default () => {
    return [
        {
            path: URLS.VENUE_PROFILE,
            exact: true,
            component: VenueProfileV2,
        },
        {
            path: URLS.VENUE_PROFILE_QUOTE,
            exact: true,
            component: VenueProfileV2,
        },
        {
            path: URLS.VENUE_PROFILE_NAME,
            exact: true,
            component: VenueProfileV2,
        },
        {
            path: URLS.VENDOR_SIGNUP,
            exact: true,
            component: NotFound,
        },
        {
            path: URLS.NOT_FOUND,
            exact: true,
            component: NotFound,
        },
        {
            path: URLS.VENUE_MANAGEMENT,
            exact: true,
            component: VenueManagement,
        },
        {
            path: URLS.DESTINATION_WEDDINGS_LANDING,
            exact: true,
            component: GuideLandingPage,
        },
        {
            path: URLS.CCPA_DO_NOT_SELL_URL,
            exact: true,
            component: CCPADoNotSellContainer,
        },
        {
            path: URLS.ALL_STYLES_LANDING_PAGE,
            exact: true,
            component: AllStylesLandingPage,
        },
        {
            path: [`${URLS.CURATED_LIST}`, `${URLS.STYLED_CURATED_LIST}`],
            exact: true,
            component: CuratedListsPage,
        },
        {
            path: URLS.MASS_INQUIRY_PAGE,
            exact: true,
            component: MassInquiryPage,
        },
        {
            path: URLS.ALL_SRP_URLS,
            exact: true,
            component: SearchResultPageComponent,
        },
        {
            path: [URLS.RFP_EMAIL],
            exact: true,
            component: RFPEmailContainer,
        },
        {
            path: HOTELS_URLS.HOTELS_SRP,
            exact: true,
            component: FLAG_ROOM_BLOCK_RECOMMENDATIONS_ENABLED ? HotelsSearch : NotFound,
        },
        {
            path: HOTELS_URLS.HOTELS_LANDING_PAGE,
            exact: true,
            component: FLAG_ROOM_BLOCK_RECOMMENDATIONS_ENABLED ? HotelsLanding : NotFound,
        },
        {
            path: URLS.CHECKOUT,
            exact: true,
            component: CheckOutWrapper,
        },
        {
            path: '/',
            exact: true,
            component: () => 'Health check OK 200',
        },
        {
            path: '',
            exact: false,
            component: NotFound,
            notFound: true,
        },
    ] as RouteConfig[];
};
